/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  general: {
    save: '保存',
    autosaved: '自動保存',
    back_to: 'に戻る',
    by: 'で',
    chat: 'チャット',
    completed: '完了',
    canceled: 'キャンセル',
    component: 'コンポーネント',
    confirm: '確認',
    course: 'コース',
    date: '日付',
    details: '詳細',
    empty: 'データなし',
    enrolled: '登録',
    free: '無料',
    graph: 'グラフ',
    loading: '読み込み...',
    lesson: 'レッスン',
    lessons: 'レッスン',
    live_assessment: 'ライブアセスメント',
    live_event: 'ライブイベント',
    no: 'ない',
    of: 'の',
    or: 'か',
    organization: '組織',
    page: 'ページ',
    pages: 'ページ',
    personal: '個人',
    poll: '投票',
    rating: 'レイティング',
    reset: 'リセット',
    signin: 'サインイン',
    signup: 'サインアップ',
    soon: 'もうすぐ',
    type: '型',
    uploading: 'アップロード...',
    yes: 'はい',
    something_went_wrong: '何かがうまくいかなかった!',
    view_all: 'すべてを見る',
    upload_successful: 'アップロードに成功しました',
    upload_successful_message:
      'Excel ドキュメントは正常にアップロードされ、現在処理中です。これには時間がかかる場合があります。',
    check_email_upload_successful: `アップロードしたユーザー一覧の <a0>Report</0> に電子メールを確認してください.`,
    is_private: 'プライベート'
  },

  account: {
    title: 'アカウント',
    subtitle: '設定とアカウント情報を管理します。',
    saved: 'アカウントが正常に変更されました'
  },

  assessments: {
    title: '評価',
    subtitle: '評価の作成',
    finished: '評価は終了しました',
    countdown: 'ライブアセスメントは放送されます',
    create: '評価の作成',
    list_title: 'あなたの評価',
    delete_warning: 'このアイテムを削除しますか?',
    details_title: '評価の詳細を追加する',
    details_subtitle:
      'アセスメントに名前を付け、視聴者に何を学ぶべきかを伝えます。',
    disclaimer: `私は、私の記録された評価が行わないことを保証します。
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
    - 他の人に対する個人的な攻撃を含む
    - 他の参加者、公人や有名人のなりすましを含む
    - 当該個人の同意なしに個人に関する記録または個人情報を含み、世界のどの部分でもデータ保護規制に違反することはありません
    - 商業的な勧誘または'スパム'の任意のフォームを含む`,
    assessment_details: '評価の詳細',
    assessment_settings: '評価設定'
  },

  buildersettings: {
    title: '公開設定',
    subtitle: 'イベントを表示して操作できるイベントに設定を追加する'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: '追加',
    add_page: 'ページの追加',
    add_lesson: 'レッスンを追加する',
    add_answer: '新しい回答を追加する',
    add_group: 'グループの追加',
    add_organization: '組織の追加',
    add_question: '質問を追加する',
    add_quiz: 'クイズの追加',
    add_users: 'ユーザーの追加',
    back: '戻る',
    back_to_course: 'コース概要に戻る',
    back_to_lesson: 'レッスンの概要に戻る',
    back_to_media: 'メディアライブラリに戻る',
    back_to_details: '詳細に戻る',
    cancel: 'キャンセル',
    clear: 'クリア',
    close: '閉じる',
    clone: 'クローン',
    close_lesson: 'クローズレッスン',
    clone_course: 'クローンコース',
    confirm: '確認',
    create: ' Create',
    download: 'ダウンロード',
    download_mass_user_tamplate: 'テンプレートをダウンロード',
    add_mass_users: '一括ユーザーを追加',
    upload_excel_list: 'Excel リストのアップロード',
    delete: 'メディアの削除',
    edit: '編集',
    edit_course: 'コースの編集',
    enroll: '登録',
    finish: '完了',
    upload_image: '画像のアップロード',
    upload_image_video: '画像や動画をアップロードする',
    select_media_library: 'メディアライブラリを選択',
    make_public: '公開',
    make_private: 'プライベートにする',
    make_org: '組織を作る',
    media: 'メディアライブラリ',
    my_theme: '私のテーマ',
    next: '次に',
    next_lesson: '次のレッスン',
    next_step: '次のステップ',
    previous_step: '前のステップ',
    publish: '公開',
    publish_assessment: '評価を公開する',
    publish_course: 'コースを公開する',
    publish_event: 'イベントを公開する',
    reset: 'リセット',
    reset_elements: '要素をリセット',
    save: '保存',
    creating: '作成...',
    updating: '更新...',
    saved: '保存',
    save_for_later: '後で保存',
    save_settings: '設定を保存',
    select_files: 'ファイルを選択',
    select_theme: 'テーマを選択してください',
    start_lesson: 'レッスンを開始',
    update: '更新',
    upload: 'アップロード',
    upload_audio: 'オーディオのアップロード',
    upload_photo: 'プロフィール写真をアップロードする',
    upload_video: '動画のアップロード',
    enrolled: '登録',
    unenroll: '登録解除',
    from_library: 'メディアライブラリ',
    remove: '削除',
    removed: '取除か',
    start_broadcast: 'ブロードキャストの開始',
    end_broadcast: 'エンドブロードキャスト',
    camera: 'カメラ',
    screen: '画面',
    screen_with_camera: 'カメラ付きスクリーン',
    insert: '挿入',

    inserting: '挿入'
  },

  card: {
    quick_add: 'クイック追加',
    add: '追加',
    clone: 'クローン',
    completed: 'レッスンが完了しました'
  },

  course: {
    upcoming_course: '今後のコース',
    unPublishEvent: '公開解除イベント',
    unPublishAssessment: '未公開評価',
    pastCourse: 'トレーニングコース',
    upcoming: '今後のライブイベント',
    pastEvent: '過去のライブイベント',
    pastAssessment: '過去のライブアセスメント',
    upcomingAssessment: '今後のライブアセスメント',
    created: '作成日:',
    assignees: '譲受人',
    organisations: ' {{ 組織 }組織、<2> {{ユーザー }} ユーザー</2>',
    event_date: 'ライブイベント日 <1> {{ 日付 }}',
    delete_warning: '削除してもよ思いますか?',
    clonning_no_lesson:
      'このコースを複製するには、少なくとも1つのレッスンを追加してください。',
    clone_warning: 'クローンを作成しますか?',
    clone_success: 'クローニングプロセス中',
    disclaimer: `私は私のコースがしないことを保証します:
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
    - 他の人に対する個人的な攻撃を含む
    - 他の参加者、公人や有名人のなりすましを含む
    - 当該個人の同意を得ることなく、いかなる個人に対しても個人情報を含め、世界のどの国のデータ保護規制にも違反しない
    - 商業勧誘または'スパム'の任意のフォームを含みます`
  },

  coursecreate: {
    dropzone_text: 'メディアの挿入',
    sidebar_text: '3/> レッスンのテーマを選択してください。',
    delete_warning: 'このレッスンを削除しますか?'
  },

  coursepage: {
    quizview_loading: '答えをチェックしています。お待ちください...',
    quizview_answer: 'あなたの答え'
  },

  coursequiz: {
    title: 'すべてのレッスンのクイズ'
  },

  dashboard: {
    tooltip_title: 'このビデオを二度と表示しない',
    page_title: 'あなたのコース統計',
    page_subtitle: '作成したコースのステータス',
    profile_add_info: `プロファイルを完了するには、<a0>{{{未完了のテキスト}}</1> を追加します。`,
    profile_build:
      'あなたのプロフィールを構築する<1>ここで</1>、あなたの興味とスキルをお知らせください。',
    profile_title: 'プロファイルの強さ',
    more_details: '詳細'
  },

  errors: {
    answer: '答えを入力してください',
    answer_correct: '正しい答えを選ぶ',
    code: 'コードを入力してください',
    criterion: '入力基準',
    duration: '期間が必要です',
    element: '入力要素',
    email: 'メールを入力してください',
    email_invalid: '入力は有効な電子メールではありません',
    feedback_correct: 'フィードバックを正しく入力してください',
    feedback_incorrect: '入力フィードバックが正しくありません',
    host: 'イベントホストを入力してください',
    host_assessment: '評価ホストを入力してください',
    image: '画像をアップロードしてください',
    location: 'あなたの場所を入力してください',
    live_location: '放送場所を選択してください',
    limit: 'ライブストリーミング分を入力してください',
    min_3char: '3 文字以上',
    number: '正の数を入力してください。',
    host_email_require: `ホストのメールが必要.`,
    attendee_email_require: '出席者のメールが必要です。',
    name: '名前を入力してください',
    not_found_course: 'コースが見つかりません',
    not_found_event: 'イベントが見つかりません',
    not_found_assessment: '評価が見つかりません',
    password: 'パスワードを入力してください',
    password_digit: '1 桁以上',
    password_short: 'パスワードが短すぎる、最小 10 文字',
    password_special: '少なくとも 1 つの特殊文字',
    password_uppercase: '大文字を少なくとも 1 つ',
    password_lowercase: '少なくとも 1 つの小文字',
    phone: 'お使いの携帯電話を入力してください',
    phone_invalid: '電話番号が無効です',
    position: 'あなたの位置を入力してください',
    question: '質問を入力してください',
    start_date: '開始日と時刻が必要です',
    tag: 'タグを選択してください',
    topics: '少なくとも 1 つのトピックを選択してください。,',
    live_topics: 'トピックを追加してください',
    title: 'タイトルを入力してください',
    title_assessment: '評価タイトルを入力してください',
    title_course: 'コースタイトルを入力してください',
    title_empty: 'タイトルは空にできません',
    title_event: 'イベントタイトルを入力してください',
    title_lesson: 'レッスンタイトルを入力してください',
    title_quiz: 'クイズ名を入力してください',
    username: 'ユーザー名を入力してください',
    upload_error: 'エラー - ファイルに互換性がありません!',
    upload_more_than_10: '一度にアップロードできるファイルは最大 10 個です。',
    topics_max: '最大で3つのトピックを追加してください。',
    upload_excel: '正しいファイルをアップロードしたことを確認してください。',
    title_excel: 'テンプレートのアップロード中にエラーが発生しました:',
    file_size_exceed: 'ファイル サイズを超えています',
    subtitle_excel:
      '提供されているテンプレートを使用し、列が正しく入力されていることを確認してください。',
    select_broadcast_option:
      'このイベントをブロードキャストするオプションを選択してください',
    multi_hosts_number_error:
      'いいえ。プレゼンターの数は、イベントに指定された値を超えることはできません。',
    conference_people_number_error: `いいえ。の出席者は、イベントに指定された範囲を超えることはできません。`,
    select_max_host: ' イベントの出席者を少なくとも 1 人選択してください。',
    select_max_conference:
      ' イベントの出席者を少なくとも 1 人選択してください。',
    stream_stop_error: 'ストリーミングが予期せず停止しました!',
    unsecure_context:
      '致命的なエラー: ブラウザは、安全でないコンテキストのためにカメラとマイクにアクセスできません。SSLをインストールして、https経由でアクセスしてください',
    ws_not_supported:
      '致命的なエラー: ウェブソケットはこのブラウザではサポートされていません',
    no_org: '続行するには、少なくとも 1 つの組織を選択してください。',
    no_org_group:
      '続行するには、少なくとも 1 つの組織グループを選択してください。',
    waiting_to_join: '誰かが参加するのを待っています！'
  },

  events: {
    title: 'ライブイベントの詳細を追加',
    change_host: 'ホストの変更',
    finished: 'イベントは終了しました',
    countdown: 'ライブイベントはで放送されます',
    subtitle: 'ライブイベントに名前を付け、視聴者に何を学ぶべきかを伝えます。',
    poll_disabled: 'このイベントではポーリングは利用できません',
    disclaimer: `私は私の記録されたイベントがしないことを保証します:
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
    - 他の人に対する個人的な攻撃を含む
    - 他の参加者、公人や有名人のなりすましを含む
    - 当該個人の同意なしに個人に関する記録または個人情報を含み、世界のどの部分でもデータ保護規制に違反することはありません
    - 商業勧誘または'スパム'の任意のフォームを含みます'`,
    prompt_message:
      'このページを離れるとイベントが終了します。このページから離れますか?',
    duration_exceed_message:
      'あなたの放送時間を超えると、アプリは放送を停止します。',
    before_schedule_message:
      '予定されたイベント時刻の前にブロードキャストを開始しようとしています。ブロードキャストを停止するとイベントが終了しますのでご注意ください。',
    browser_unsupportive_message:
      'お使いのブラウザーはスクリーン共有をサポートしていません。このリンクでサポートされているブラウザを見ることができます',
    cancel_switch_host_message:
      'ホストは使用できません。イベントはあなたの終わりから続きます。',
    coaching_prompt_message:
      'イベントが終了するまで、このページを離れることはできません。',
    event_modal_warn: 'このイベントを離れますか?',
    confirm_message: 'OK をクリックすると、イベントは終了します。',
    screen_share_denied: '画面の共有を拒否しました',
    media_not_found:
      'カメラまたはマイクが見つからないか、お使いのデバイスで許可されていません。',
    media_not_access:
      'カメラまたはマイクは、デバイスを読み取らない他のプロセスで使用されています',
    constraint_error:
      'ビデオとオーディオの制約に合ったデバイスが見つかりません。ビデオとオーディオの制約を変更することができます',
    media_access_denied: 'カメラとマイクにアクセスすることはできません.'
  },

  filters: {
    days7: '過去7日間',
    days15: '最後の15日間',
    days30: '過去30日間',
    days365: '過去365日間',
    date: '作成日',
    relevance: '関連性',
    popularity: '人気',
    name: '名前',
    group: 'グループ',
    Newest_to_Oldest: '最新から最も古い',
    Oldest_to_Newest: '最も古いものから最新の',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'アカウントのセキュリティを確保するために、パスワードに少なくとも1つの小文字の番号が必要です。また、10 文字の最小長を持つ必要があります。',
    phone: 'お使いの携帯電話の国コードを含めてください。,例えば:+65',
    username:
      'ユーザー名は公開情報として扱われ、必要に応じて他のユーザーと共有されます。そのため、ユーザー名に個人情報を使用しないことをお勧めします。',
    public_description_normal: `<0></0/0/0> は保存されており、既定ではプライベートと見なされます。つまり、このコンテンツは自分だけが見ることができます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、プラットフォームのすべてのユーザーが利用できるようになります。特定のユーザーオプションを使用すると、共有の外観 アカウントに関連付けられた電子メール アドレスを使用して、特定のユーザーとコースを共有できます。`,
    public_description_admin:
      'この <0></0/0/</0> は保存されており、既定ではプライベートと見なされます。つまり、このコンテンツは、あなた (およびコンテンツ作成者) だけが表示できます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、組織外のユーザーを含め、プラットフォーム内のすべてのユーザーが利用できるようになります。組織に公開すると、組織内のすべてのユーザーが表示できるようになります。また、1 つ以上のグループに公開することもできます。 最後に、共有の外観 アカウントの電子メール アドレスを使用して、組織内外の特定のユーザーに公開するオプションがあります。'
  },

  labels: {
    add: '追加',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: '回答の種類',
    answers: '答え',
    back_to_quiz: 'クイズリストに戻る',
    back_to_question: '質問リストに戻る',
    chat: 'チャット',
    chat_available: 'このイベントではチャットは利用できません',
    chat_report: 'チャットレポート',
    choice_single: '単一の選択肢',
    choice_multiple: '複数の選択肢',
    choice_free: '"無料"の選択',
    choice_sorting: '"並べ替え"の選択',
    choice_matrix: '"マトリックスソート"の選択',
    clone_lesson_permission: 'クローンアクセス許可',
    code: 'コード',
    correct: '正しい',
    created: '作成日',
    clone_modal: 'クローンコース',
    cloning_course: 'クローニングコース...',
    cloning: 'クローニング。..',
    cloning_course_desc:
      'このプロセスにはしばらく時間がかかります。我慢してください',
    cloning_success: 'コース"</>"は正常にクローン化されています!',
    description: '説明',
    disclaimer: '免責事項',
    drop_file: 'ここにファイルをドロップする...',
    duration: '持続時間',
    edit: '編集',
    email: '電子メール',
    event: 'イベント',
    event_all: 'イベント ...',
    event_date: 'ライブイベント ローカル日時',
    event_this: 'このイベント',
    expire: '有効期限',
    expiry_date: '有効期限',
    forgot: 'パスワードを忘れた場合?',
    group: 'グループ',
    groups_list: 'グループのリスト',
    host: 'ホスト',
    id_annotation: '注釈 ID',
    id_quiz: 'クイズID',
    incorrect: '誤った',
    interests: '興味',
    invited: '招待',
    live_chat: 'ライブディスカッション',
    live_stream_limit: 'ライブストリーミングの分',
    contact_text:
      '毎月のライブストリーミング制限を変更するには、お問い合わせください',
    contact_admin:
      '<0>毎月のライブストリーミング制限を変更したい場合は、</0> </admin@共有の外観.com</0> までお問い合わせください。',
    limit_stream_text:
      'ライブストリーミング残り時間: <0>{{制限 }}</0> 分 <1/></2>毎月のライブストリーミング制限を変更するには、</3> </admin@共有の外観.com</4> までお問い合わせください。',
    location: '場所',
    lessons: 'レッスン',
    location_broadcast: 'ホスト サーバーの場所',
    location_broadcast_subtitle:
      '視聴覚の遅延を減らすために放送ホストの場所に最も近い場所を追加します。',
    media_manager: 'メディアマネージャー',
    minutes: '分',
    name: '名前',
    online_quiz: 'オンラインクイズ',
    organiser: '著者',
    organization: '組織',
    overall_emotion: '全体的な経験:',
    organizations_list: '組織一覧',
    password: 'パスワード',
    participants: '参加者',
    picture: '絵 (16:9)',
    phone: '電話',
    photo: '写真',
    poll: '投票 ',
    position: '位置',
    processing: '処理',
    privacy_settings: 'プライバシー設定',
    question: '質問',
    quiz_create: '新しいクイズの作成',
    quiz_name: 'クイズ名',
    quiz_update: '更新クイズ',
    select_organization: '組織を選択してください',
    settings: '設定',
    show: '表示',
    show_graph: 'グラフ結果を表示する',
    signin: 'サインイン',
    signup: 'サインアップ',
    sort_by: '並べ替え',
    start_date: '開始日',
    tags: `私はこれらの<1>利用規約に同意します。</a0>`,
    terms: '私はこれらの<1>利用規約に同意します。</a0>',
    title: 'タイトル',
    topics: 'トピック',
    topic: 'トピック',
    total_comments: '合計コメント',
    username: '名',
    users_list: 'ユーザーのリスト',
    users_emails: '特定のユーザーの電子メールを挿入する',
    description_specifiction_email:
      '複数の特定のユーザーと共有するには、1 行に 1 つの電子メール アドレスを入力してください。',
    message_specific_email: '指定ユーザーのメールを入力してください。',
    viewers: '視聴者',
    edit_course: '編集',
    edit_assessment: '編集',
    edit_event: '編集',
    delete_course: '削除',
    delete_event: '削除',
    delete_assessment: '削除',
    view_course: '見る',
    view_event: '見る',
    view_assessment: '見る',
    date_event: 'ライブイベントの日付',
    date_assessment: 'ライブ評価日',
    clone_of: 'クローン',
    clone_course: `このコースのクローンを作成して、オリジナルとは別に変更でき、すべてのレッスンとページが含まれます。`,
    make: '作る',
    available_to: '任意の 共有の外観 ユーザーが利用できる',
    uploaded_by: 'アップロードする人:',
    course: 'コース',
    assessment: '評価',
    user_not_exist: 'ユーザーが存在しません、 招待を送信しますか?',
    check_user: 'お知らせ',
    user_not_exist_in_org: 'ユーザーがこの組織に存在しません。',
    title_modal_stream: '組織のライブストリーム制限の変更',
    des_warning_stream: 'あなたは変わろうとしている',
    monthly_stream: '毎月のライブストリーミング制限:',
    min_per_month: '分/月',
    broadcast_label: '私はやりたい:',
    hosts_emails: `特定のホストの電子メールを挿入します。`,
    attendee_emails: `特定の出席者の電子メールを挿入する`,
    description_host_specifiction_email:
      '1 行につき 1 つの電子メール アドレスを入力してください。',
    presenter_label: 'プレゼンター',
    presenter_label_conference: '人々のNo.',
    event_privacy: '会議モード'
  },

  broadcastOptions: {
    stream_from_phone: '私の携帯電話でライブ放送',
    other_webrtc: '私のPCからのウェビナー',
    multihost: 'マイ PC からのマルチキャスト ウェビナー',
    peer2peer: 'コーチングセッション',
    conference: 'ライブカンファレンス'
  },

  lessoncreate: {
    title: 'レッスンの詳細を追加',
    subtitle: 'レッスンに名前を付け、聴衆に何を学ぶべきかを伝えます。',
    input_label_title: 'レッスンタイトル',
    input_label_topics: 'レッスントピック',
    input_label_description: 'レッスンの説明',
    delete_warning: 'このページを削除しますか?'
  },

  lessonoverview: {
    title: 'レッスンの追加',
    subtitle: '既存のレッスンを追加または新しいレッスンを作成する',
    new_lesson: '新しいレッスンを作成する',
    new_lesson_sub: 'ゼロから新しいレッスンを作成!',
    existing_lesson: '既存のレッスンを選択してください',
    existing_lesson_sub:
      '既存のレッスンにリンクすると、このレッスンに加えた変更は、他のコースでもこのレッスンに影響を与えます。',
    clone_lesson: '既存のレッスンを複製',
    clone_lesson_sub:
      'このコースのレッスンを独自にコピーすると、このレッスンに加えた変更は元のレッスンには影響しません。',
    clone_lesson_modal_sub:
      'コースに追加するレッスンの下にあるクローンボタンをクリックしてください。'
  },

  management: {
    groups_title: 'グループの管理',
    delete_warning: 'よいですか?',
    organizations_title: '私の組織',
    organizations_subtitle: 'リストに組織を追加する',
    users_title: 'ユーザーの管理',
    users_position: 'シニアアカウントマネージャー',
    user_not_found: 'ユーザーが見つかりません',
    select_org: 'ユーザーを管理する組織を見つけて選択してください'
  },

  audio: {
    modal_title: 'オーディオの挿入',
    list_view: 'リストビュー',
    create_audio_modal_title: 'オーディオの作成',
    edit_audio_modal_title: 'オーディオの編集',
    public_audio_not_found: 'オーディオが見つかりません。',
    private_audio_not_found: 'まだオーディオをアップロードしていません',
    are_you_sure_to_delete: '削除してもよいですか?',
    type_something: '何かを入力してください',
    select_voice: '選択',
    file_name: 'ファイル名',
    description: '説明',
    topic: 'トピック',
    key_words_tag: 'キーワードタグ',
    mp3_audio: 'MP3オーディオ',
    created: '作成',
    duration: '期間',
    close: '閉じる'
  },

  image: {
    modal_title: 'イメージの挿入',
    image: '画像',
    pixel: 'ピクセル',
    dimension: 'ディメンション',
    public_image_not_found: '画像が見つかりません。',
    private_image_not_found: 'まだ画像をアップロードしていません'
  },

  annotation: {
    modal_title: 'アノテーション'
  },

  text: {
    modal_title: 'テキストエディタ'
  },

  video: {
    modal_title: 'ビデオの挿入',
    image: 'ビデオ',
    mp4_video: 'MP4ビデオ',
    public_video_not_found: 'ビデオが見つかりません。',
    private_video_not_found: 'まだ動画をアップロードしていません'
  },

  media: {
    title: 'メディアライブラリ',
    subtitle: 'あなたのファイルのライブラリ',
    modal_title: 'メディアのアップロード',
    delete_warning: '削除の確認',
    delete_message:
      '削除されたメディアは、使用されたページに引き続き表示されます。',
    dropzone_text: 'またはドラッグアンドドロップ',
    delete_success: 'メディアは正常に削除されました',
    upload_file: 'ファイルのアップロード',
    drag_drop: 'またはドラッグアンドドロップ',
    import_file: 'コンピュータからファイルをインポートする',
    no_media: 'まだメディアをアップロードしていません',
    media_type: 'メディアタイプ',
    video: 'ビデオ',
    image: 'イメージ',
    audio: 'オーディオ',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'メディアが見つかりません.',
    of: 'の',
    disclaimer: `私は私のメディアがしないことを保証します:
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
  - 他の人に対する個人的な攻撃を含む
  - 他の参加者、公人や有名人のなりすましを含む
  - 当該個人の同意を得ることなく、いかなる個人に対しても個人情報を含め、世界のどの国のデータ保護規制にも違反しない
  - 商業勧誘または'スパム'の任意のフォームを含みます`,
    my_media: 'マイメディア',
    public_library: '公共図書館',
    organization_library: '組織図',
    upload_from_computer: 'コンピュータからアップロード',
    create: '作成',
    all: '全て',
    male: '男性',
    female: '女性',
    processing_audio: 'オーディオを処理しています',
    create_annotation: '注釈の作成',
    popup_over_lesson_text:
      'クリック後に、注釈がレッスンページにポップアップ表示されます',
    edit_detail: '詳細の編集',
    delete: '削除',
    go_create_audio: '音声を作成する',
    show_more_details: '詳細を表示',
    show_less_details: '詳細を表示する',
    drop_files: 'ドロップファイルとアップロードする場所',
    or: 'か',
    import_files: 'コンピュータからファイルをインポートする'
  },

  navigation: {
    account: 'アカウント',
    assessments: '評価',
    dashboard: 'ダッシュ ボード',
    groups: 'グループマネジメント',
    logout: 'ログアウト',
    organisations: '組織の',
    organizations_users: '組織とユーザー',
    reports: 'レポート',
    schedule: 'スケジュール',
    training: 'トレーニング',
    users: 'ユーザー',
    workshop: '私のワークショップ',
    nowLive: '放送'
  },

  onboarding: {
    step1_title: 'ステップ1:あなた自身について少し教えてください',
    step1_subtitle: 'あなたの名前は何ですか?ご出身は。あなたの役職は何ですか?',
    step2_title:
      'ステップ2:あなたが改善することができるいくつかのスキルを選択してください',
    step2_subtitle:
      '次に、より良い理解を得たいことを教えてください。おそらく、あなたはまだ拾っていない何か?新しい研究分野?あなたの愛する人は何をしますか?'
  },

  pagebuilder: {
    title: 'レッスンの作成',
    subtitle:
      '視聴者があなたから学ぶためにコンテンツを作成する時間、あなたは写真、ビデオ、インフォグラフィックをすることができます',
    select_layout: 'ページレイアウトを選択',
    template1: 'ブランク',
    template2: 'タイトルとサブタイトル',
    template3: 'タイトルとテキスト',
    template4: 'タイトル、メディア、テキスト',
    template5: 'タイトルとメディア',
    template6: 'タイトルとクイズ'
  },

  pageconstructor: {
    title: 'レッスンの作成とクローン作成',
    subtitle:
      '視聴者があなたから学ぶためにコンテンツを作成する時間、あなたは写真、ビデオやインフォグラフィックを追加することができます'
  },

  passwordreset: {
    success_coded:
      '入力したアドレスに確認コードを電子メールで送信しましたので、以下のフィールドにコードをコピーして新しいパスワードを設定してください。',
    success_changed:
      '新しいパスワードを設定しました。今すぐサインインできます。'
  },

  placeholders: {
    search: '検索',
    answer: '答え',
    chat: '何かを言う...',
    code: 'コード',
    criterion: '基準',
    date_event: '日付と時刻を選択',
    date_start: '開始日',
    date_expire: '有効期限',
    description: '説明',
    elements: '要素を並べ替える',
    email: '電子メール',
    feedback_correct: 'フィードバックが正しい',
    feedback_incorrect: 'フィードバックが正しくありません',
    host: 'ホスト',
    keywords: '検索キーワード',
    lesson_description: 'レッスンの説明',
    location: '場所',
    minutes: '分',
    name: '名前',
    organiser: '著者',
    organization: '組織',
    password: 'パスワード',
    phone: '電話',
    photo: '写真',
    picture: '画像',
    point: 'ポイント',
    position: '位置',
    question: '質問',
    quiz: 'クイズ名',
    search_course: 'コースで検索',
    search_media: '検索メディア',
    search_name: '名前で検索',
    search_title: 'タイトルで検索',
    search_training: '検索トレーニング',
    settings: '設定',
    tags: 'タグ',
    title: 'タイトル',
    topics: 'トピック',
    username: '名',
    keyword: 'キーワード',
    max_500_characters: '最大500文字',
    no_description: 'このファイルには説明がありません',
    no_keyword: 'このファイルにはキーワードがありません',
    no_topics: 'このファイルにはトピック セットがありません',
    feedback: 'メッセージ',
    contact: '私たちがどのように助けることができるか?'
  },

  publishsettings: {
    title: '公開設定',
    event_subtitle: 'イベントを表示して操作できるイベントに設定を追加する',
    assessment_subtitile: '評価に名前を付け、視聴者に何を学ぶべきかを伝える',
    course_subtitle: '設定をコースに追加し、コースを表示して操作できます。',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: '両方の日付を入力する必要があります。',
    emails_validation_error: '電子メールリストが無効です。',
    specific_email_validation_error: '1つの電子メールのみが許可されます。',
    i_agree_to_these: '私はこれらに同意します',
    terms_and_conditions: '利用規約。',
    PublicDescription:
      '無料の独立ユーザー:(プライベートおよびパブリックオプション)あなたの[コース|]イベント|[評価]は保存されており、デフォルトでは非公開と見なされます。つまり、このコンテンツは自分だけが見ることができます。このコンテンツを公開するには、以下のコンテンツを公開するよう選択できます。つまり、このコースはプラットフォーム内のすべてのユーザーが利用できるようになります。',
    OrganisationsDescription:
      '組織ユーザー: (""Finish"""の代わりに""Finish""を使用して"発行""を使用し、他のユーザーと同じ発行ページに移動しますが、公開オプションはありません)。あなたの [コース|イベント|[評価]は保存され、プライベートです。つまり、組織内の管理者だけがそれを表示できます。管理者の権限が必要なため、ユーザーは自分でコンテンツを組織内に公開することはできません。管理者に連絡して、コンテンツを公開、組織全体、組織内の特定のグループ、または特定のユーザーに公開するよう依頼してください。',
    OrganisationGroupsDescription: `組織管理者: (組織内で作成されたコンテンツ: プライベート、パブリック、組織、グループ、特定のユーザー): この [コース|イベント|[評価]は保存されており、デフォルトでは非公開と見なされます。つまり、このコンテンツは、あなた (およびコンテンツ作成者) だけが表示できます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、組織外のユーザーを含め、プラットフォーム内のすべてのユーザーが利用できるようになります。組織に公開すると、組織内のすべてのユーザーが表示できるようになります。また、1 つ以上のグループに公開することもできます。 最後に、共有の外観 アカウントの電子メール アドレスを使用して、組織内外の特定のユーザーに公開することもできます。`,
    SpecificUsersDescription:
      '有料の独立ユーザー:(プライベート、パブリック、特定のユーザー)あなたの[コース|]イベント|[評価]は保存されており、デフォルトでは非公開と見なされます。つまり、このコンテンツは自分だけが見ることができます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、プラットフォームのすべてのユーザーが利用できるようになります。特定のユーザーオプションを使用すると、共有の外観アカウントに関連付けられたメールアドレスを使用して、特定のユーザーとコースを共有できます。'
  },

  quiz: {
    quiz_empty: 'まだクイズを作成していません',
    questions_empty: 'まだ質問を作成していません'
  },

  regions: {
    asia_pacific_australia: 'オーストラリア',
    asia_pacific_india: 'インド',
    asia_pacific_japan: '日本',
    asia_pacific_s_korea: '韓国',
    asia_pacific_singapore: 'シンガポール',
    asia_pacific_taiwan: '台湾',
    eu_belgium: 'ベルギー',
    eu_germany: 'ドイツ',
    eu_ireland: 'アイルランド',
    south_america_brazil: 'ブラジル',
    us_central_iowa: 'アイオワ',
    us_east_s_carolina: 'サウスカロライナ州',
    us_east_virginia: 'バージニア',
    us_west_california: 'カリフォルニア',
    us_west_oregon: 'オレゴン'
  },

  reports: {
    title: 'レポート',
    workshop_report: 'ワークショップレポート',
    user_report: 'ユーザー レポート',
    organization_workshop: '組織ワークショップ',
    course: 'コース',
    live_event: 'ライブイベント',
    workShop_graph: 'ワークショップグラフ',
    organization_account: `組織アカウント`,
    all: '全て',
    name: '名前',
    id_number: 'ID番号',
    email: '電子メール',
    search_user_report: '検索ユーザーレポート',
    participant: '参加者',
    participants: '参加者',
    host: 'ホスト',
    username: 'ユーザー名',
    event: 'イベント',
    quiz: 'クイズ',
    assessment: '評価',
    time: '時間',
    no_recent_activity: '最近の活動はありません',
    workshops: 'ワーク ショップ',
    courses: 'コース',
    live_events: 'ライブイベント',
    live_assessments: 'ライブアセスメント',
    quizzes: 'クイズ',
    overview: '概要',
    by: 'で',
    views: '表示モード',
    status: 'ステータス',
    poll: '投票',
    comment: 'コメント',
    comments: 'コメント',
    no_comments: 'コメントなし',
    no_polls: '投票なし',
    live_date: 'ライブデート',
    score: 'スコア',
    question: '質問',
    submit: '送信',
    recent_activity: '最近の活動',
    ago: '前',
    no_data_found: 'データが見つかりません',
    start_end_live: '開始/ライブ終了',
    join_leave_date: '参加/退会',
    watched_time: '視聴時間',
    complete: '完了',
    in_complete: '不完全',
    today: '今日',
    seven_days: '7日間',
    last_month: '先月',
    one_year: '1年',
    all_time: 'オールタイム',
    report: 'レポート',
    from_date: '開始日',
    to_date: '終了日まで',
    all_workshop: 'オールワークショップ',
    all_participants: 'すべての参加者',
    live_assessment: 'ライブアセスメント',
    users: 'ユーザー',
    download: 'ダウンロード',
    recent: '最近',
    WorkShop: 'ワーク ショップ',
    Activity: '活動',
    created_date: '作成日',
    lessons: 'レッスン',
    lesson: 'レッスン',
    completed: '完了',
    report_download: 'レポートダウンロード',
    this_month: '今月',
    search_course: '検索コース',
    participants_graph: '参加者グラフ',
    viewed: '表示',
    enrolled: '登録',
    description: '説明',
    topic: 'トピック',
    analytic: '分析',
    quiz_list: 'クイズリスト',
    select_one: '1つを選択',
    group_status: 'グループステータス',
    duration_min: '期間(分)',
    submit_poll: '投票の送信',
    download_events: 'ダウンロードイベント',
    search_event: '検索イベント',
    duration: '期間',
    total_participants: '参加者の合計',
    message: 'メッセージ',
    avg_message: '平均メッセージ',
    per_message: 'メッセージ/イベントの割合'
  },

  signup: {
    success_step1:
      'ご提供いの住所に確認コードを電子メールで送信しましたので、下記の欄にコードをコピーして登録を確認してください。',
    success_step2: 'ありがとう。登録が完了しました。',
    privacy:
      '私は共有の外観の<1>利用規約</1>と<3>プライバシーポリシーに同意します。</3>'
  },

  stream: {
    emotion_impressive: '印象的',
    emotion_unimpressive: '印象的ではない',
    message_not_started: 'もうすぐ',
    message_running: 'ライブ',
    message_processing:
      '現在、ライブ録音を再生用に処理しています。後でもう一度確認してビデオを表示し、評価とフィードバックを追加し続けてください'
  },

  tabs: {
    audience: '観客',
    course: 'コース概要',
    details: 'ライブイベントの詳細',
    description: '説明',
    host: 'ホスト',
    lesson: 'レッスンの概要',
    lessons: 'レッスン',
    overview: '概要',
    page: 'ページビルダー',
    publish: '公開',
    settings: '公開設定',
    total_views: '総表示',
    live_participates: 'ライブ参加者',
    live_chats: 'ライブチャット',
    live_quiz: 'ライブ投票',
    trainer_rating: 'トレーナー評価',
    trainer_times: 'トレーナータイムズ',
    courses_quizzes: 'コースクイズ',
    user_list: 'ユーザーリスト',
    discussion: '議論',
    notes: '私のノート'
  },

  topics: {
    SALES_TRAINING: 'セールストレーニング',
    NEGOTIATION_TRAINING: '交渉訓練',
    CROSS_CULTURAL_AWARENESS: '異文化意識',
    NETWORKING_SKILLS: 'ネットワーキングスキル',
    SOFTWARE_ARCHITECTURE: 'ソフトウェアアーキテクチャ',
    PROJECT_MANAGEMENT: 'プロジェクト管理',
    DIGITAL_TRANSFORMATION: 'デジタルトランスフォーメーション',
    IT_CONSULTING: 'ITコンサルティング',
    MANAGEMENT_CONSULTING: '経営コンサルティング',
    HR_CONSULTING: '人事コンサルティング',
    INTERNET_OF_THINGS: 'モノのインターネット(IoT)',
    CYBERSECURITY: 'サイバーセキュリティ',
    PRIVACY_AND_GDRP: 'プライバシーとGDPR '
  },

  training: {
    title: 'トレーニング',
    title_assessment: '評価',
    subtitle: 'コースとライブイベント',
    enrolled_title: '登録コースとライブイベント',
    enrolled_subtitle: '登録したコースとライブイベント',
    enrolled_message: '現在、コースやイベントに登録されていません。',
    past_live_event_title: '過去のライブイベント',
    past_live_event_subTitle: 'ライブイベントの終了',
    past_live_event: 'おすすめコースとライブイベント',
    recomended_title: 'おすすめコースとライブイベント',
    now_live_event_title: '今すぐライブ',
    now_live_event_subTitle: 'ライブイベントやまもなく開催されるイベント',
    now_live_event: '現在、ライブイベントはありません。',
    webinar_event_title: 'ウェビナーチャンネル',
    webinar_event_subTitle: '完成したウェビナー',
    webinar_event: '現在、ウェビナーはありません。',
    p2p_event_title: 'コーチングセッション',
    p2p_event_subTitle: 'コーチングセッション終了',
    p2p_event: '現在、コーチングセッションはありません。.',

    now_live_assessment_title: '今すぐライブ',
    now_live_assessment_subTitle: '生きているか、すぐに起きる評価',
    now_live_assessment_message: '現在、ライブアセスメントはありません。',

    upcoming_assessment_title: '今後のライブアセスメント',
    upcoming_assessment_subtitle: '今後のライブアセスメント',
    upcoming_assessment_message: '現在、今後のライブ評価はありません。',

    past_live_assessment_title: '過去のライブ評価',
    past_live_assessment_subTitle: '完成したライブ評価',
    past_live_assessment_message: '現在、過去のライブ評価はありません。',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle: `<a0></0/0></a0> に基づいてコースとライブイベントをキュレーションしました。`,
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: '検索トレーニング',
    search_assessment: '検索アセスメント',
    recomended_message: '現在、推奨されるコースやイベントはありません。'
  },

  warnings: {
    delete: '本当に?'
  },

  workshop: {
    title: '私のワークショップ',
    subtitle: 'コースを作成するか、あなた自身のライブイベントを主催する',
    new_course: '新しいコースを作成する',
    new_event: '新しいライブイベントを作成する',
    new_assessment: '新しいライブ評価を作成する',
    courses_title: '作成されたコースとライブイベント',
    courses_subtitle: '作成したコースを編集・公開し、ライブイベントを計画する',
    tags_course: 'コース',
    tags_live: 'ライブイベント',
    tags_assessment: 'ライブアセスメント'
  },

  help_center: {
    sidebar: {
      title: 'どのように私たちはあなたを助けることができますか?',
      back_to: 'ダッシュ ボード'
    },
    menu: {
      help_center: 'ヘルプセンター',
      whats_new: '新機能',
      feedback: 'フィードバック',
      feedback_title: 'フィードバックを送信して見た目を共有する',
      terms_and_conditions: '利用規約',
      privacy_policy: 'プライバシーポリシー',
      contact_us: 'お問い合わせ'
    },
    get_started: {
      title: '共有ルックを始める',
      description: {
        main: '私たちは、使いやすいコースビルダーにライブビデオを統合しました',
        tagline:
          '共有の外観の特許取得済みのライブ放送システムを使用すると、エンゲージメントを作成し、学習を自動化し、知識共有を最大化することができます。'
      }
    },
    whats_new: {
      title: '共有ルックを始める',
      description: {
        main:
          'ストーリーテリングスタイルの学習を作成すると、短時間で作成でき、それほど高価ではないことをご存知でしたか? 共有の外観コースビルダーとそれぞれの才能を組み合わせる必要があります。あなたは私たちに尋ねることができます "HOW',
        tagline: ''
      }
    },
    create_workshop: 'ワークショップの作成方法',
    create_course: 'コースの作成方法',
    create_user: 'ユーザーを作成する方法',
    create_group: 'グループの作成方法',
    create_webinar: 'ウェビナーの作成方法',
    create_live_event: 'ライブイベントの作成方法',
    create_live_assessment: 'ライブアセスメントの作成方法',
    create_live_on_mobile: 'モバイルでライブを作成する',
    personalize_profile: 'プロフィールをパーソナライズする',
    manage_group: 'グループの管理',
    report: 'レポート',
    add_annotations: '注釈/ポップアップを追加する方法',
    add_audio: 'オーディオを追加する方法',
    add_header_and_footer: 'ヘッダーとフッターの追加',
    add_image: '画像を追加する方法',
    add_quiz_content: 'クイズコンテンツの追加方法',
    add_text_content: 'テキストコンテンツを追加する方法',
    add_user: 'ユーザーを追加する方法',
    add_video: 'ビデオを追加する方法',
    clone_course: 'コースのクローン作成方法',
    find_live_broadcast: 'ライブ放送の見つけ方',
    contact_us: {
      title: 'お問い合わせ',
      subject_placeholder: '件名を入力します。*',
      content_placeholder: 'メッセージを入力する*',
      subject_required: '*件名が必要です',
      content_required: '*メッセージが必要です',
      submit: '送信',
      cancel: 'キャンセル',
      sent: '送信済み'
    },
    feedback: {
      title: 'フィードバックを送信して見た目を共有する',
      attach_title: 'ファイルを添付する',
      choose: 'ファイルを選択',
      detail: 'ファイルはサポート チームと共有されます',
      content_placeholder: 'メッセージを入力する*',
      content_required: '*メッセージが必要です',
      submit: '送信',
      cancel: 'キャンセル',
      sent: '送信'
    }
  },
  discussion: {
    join_discussion: 'ディスカッションに参加'
  },
  notes: {
    title: '私のノート',
    add_note: '新しいメモを追加する'
  }
}
